import { URLS } from '@assets/environment/urls'

export type AuthTokenStorageConfig = {
	appId: string
	issuer: string
	clientId: string
	schemaVersion: number
	databaseName: string
	databaseVersion: number
	broadcastChannelName: string
	refreshLockName: string
}

const issuerBase = URLS.KC_URL.replace(/\/+$/, '')
const issuerRealm = URLS.KC_REALM.replace(/^\/+|\/+$/g, '')

export const AUTH_TOKEN_STORAGE_CONFIG: AuthTokenStorageConfig = {
	appId: 'club.tisit.mobile',
	issuer: `${issuerBase}/realms/${issuerRealm}`,
	clientId: URLS.KC_USER,
	schemaVersion: 1,
	databaseName: 'tisit-auth-token-vault',
	databaseVersion: 1,
	broadcastChannelName: 'tisit-auth-token-vault-events-v1',
	refreshLockName: 'tisit-auth-token-refresh-v1',
}
